import { useState } from "react";
import { KeyRound } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export function ChangePasswordDialog({ triggerClassName }) {
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const reset = () => { setCurrent(""); setNext(""); setConfirm(""); };

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 8) {
      toast.error("Kata laluan baharu mesti sekurang-kurangnya 8 aksara");
      return;
    }
    if (next !== confirm) {
      toast.error("Kata laluan baharu tidak sepadan");
      return;
    }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Kata laluan berjaya ditukar");
      setOpen(false);
      reset();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { setOpen(v); if (!v) reset(); }}>
      <DialogTrigger asChild>
        <button data-testid="change-password-trigger" className={triggerClassName}>
          <KeyRound className="w-4 h-4" /> Ubah Kata Laluan
        </button>
      </DialogTrigger>
      <DialogContent data-testid="change-password-dialog">
        <DialogHeader><DialogTitle>Ubah Kata Laluan</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label>Kata Laluan Semasa</Label>
            <Input data-testid="change-password-current-input" type="password" required value={current} onChange={(e) => setCurrent(e.target.value)} className="mt-1.5" />
          </div>
          <div>
            <Label>Kata Laluan Baharu</Label>
            <Input data-testid="change-password-new-input" type="password" required minLength={8} value={next} onChange={(e) => setNext(e.target.value)} className="mt-1.5" />
          </div>
          <div>
            <Label>Sahkan Kata Laluan Baharu</Label>
            <Input data-testid="change-password-confirm-input" type="password" required minLength={8} value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1.5" />
          </div>
          <Button type="submit" disabled={saving} data-testid="change-password-submit-btn" className="w-full bg-piks-black hover:bg-piks-black/90">
            {saving ? "Menyimpan..." : "Simpan Kata Laluan Baharu"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
